/* Zoom mobile (thème Blockshop)
   La modal de zoom est rendue dans .product-page--desktop-container,
   masqué (display:none) sous 768px -> la modal est invisible en mobile.
   On la déplace dans <body> pour qu'elle s'affiche, puis on l'ouvre au tap. */
(function () {
  function isMobile(){ return window.matchMedia('(max-width: 767px)').matches; }

    function relocateModal(){
    var modal = document.querySelector('.product-page--desktop-container modal-root[data-id="product"]');
    if (modal && modal.parentElement !== document.body) {
        document.body.appendChild(modal);
    }
    // les flèches de nav doivent aussi être dans body, au-dessus de la modal
    ['.layout--next', '.layout--previous'].forEach(function(sel){
        var btn = document.querySelector(sel);
        if (btn && btn.parentElement !== document.body) document.body.appendChild(btn);
    });
    }

  function viewIndexForMedia(mediaId){
    var views = document.querySelectorAll('modal-root[data-id="product"] .modal--view');
    for (var i=0;i<views.length;i++){ if (views[i].dataset.id === mediaId) return i; }
    return 0;
  }

  function bind(){
    relocateModal();

    var carousel = document.querySelector('.product-page--carousel');
    if (!carousel) return;

    carousel.querySelectorAll('.product-media--root').forEach(function(root){
      if (root.dataset.zoomBound) return;
      root.dataset.zoomBound = '1';
      root.addEventListener('click', function(e){
        if (!isMobile()) return;
        var modal = window.theme && theme.modal && theme.modal.instances['product'];
        if (!modal) return;
        e.preventDefault();
        e.stopPropagation();
        modal.toggleView(viewIndexForMedia(root.dataset.id), false);
        modal.open();
      }, true);
    });
  }

  if (document.readyState !== 'loading') bind();
  else document.addEventListener('DOMContentLoaded', bind);
})();

/* Drawer thème désactivé + déblocage scroll après fermeture Essential Cart */
(function () {
  var vp = document.querySelector('.layout--viewport');

  function unlockScroll() {
    var savedY = 0;
    var mc = document.querySelector('.layout--main-content');

    // récupère la position mémorisée dans le top négatif
    if (mc && mc.style.top) {
      var t = parseInt(mc.style.top, 10);
      if (!isNaN(t) && t < 0) savedY = -t;
    }
    if (!savedY && vp && vp.style.top) {
      var tv = parseInt(vp.style.top, 10);
      if (!isNaN(tv) && tv < 0) savedY = -tv;
    }

    if (vp) {
      vp.setAttribute('data-drawer-status', 'closed');
      vp.removeAttribute('data-drawer-view');
      vp.style.position = '';
      vp.style.top = '';
    }
    if (mc) {
      mc.style.position = '';
      mc.style.top = '';
    }
    document.documentElement.style.overflow = '';
    document.body.style.overflow = '';
    document.body.style.position = '';
    document.body.style.top = '';

    if (savedY) window.scrollTo(0, savedY);
  }

  // 1) neutralise le drawer du thème dès qu'il tente de s'ouvrir
  if (vp) {
    new MutationObserver(function () {
      if (vp.getAttribute('data-drawer-view') === 'cart-drawer' &&
          vp.getAttribute('data-drawer-status') !== 'closed') {
        try { if (window.theme && theme.drawer && theme.drawer.close) theme.drawer.close(); } catch(e){}
        unlockScroll();
      }
    }).observe(vp, { attributes: true, attributeFilter: ['data-drawer-status', 'data-drawer-view'] });
  }

  // 2) surveille la classe sur <html> : essential-cart__closed = drawer fermé -> on débloque
  new MutationObserver(function () {
    if (document.documentElement.className.indexOf('essential-cart__closed') !== -1) {
      unlockScroll();
    }
  }).observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });

  unlockScroll();
})();